import { on, select, selectAll, addClass, removeClass, getData, setAttribute } from 'modules/dom'
import { fetchData } from 'modules/utils'

const FORM_CHECK_USE_GOOGLE = '.js-form-check-use-google'
const BUTTON_FORM_CHECK_USE_GOOGLE = '.js-button-check-use-google'
const INPUT_RADIO_CHECK_USE_GOOGLE = 'input[name="check_use_google"]:checked'
const INPUT_MAGIC_BOX_LOGIN = '.js-magicbox-login-url'
const LOADING_CHECK_USE_GOOGLE = '.js-button-check-use-google-loading'

const ACTIVATE_CLASS = 'active'

const formCheckUseGoogle = select(FORM_CHECK_USE_GOOGLE)
const buttonFormCheckUseGoogle = select(BUTTON_FORM_CHECK_USE_GOOGLE, formCheckUseGoogle)
const loadingFormCheckUseGoogle = select(LOADING_CHECK_USE_GOOGLE, formCheckUseGoogle)

export default function (el) {
  const openModalButton = selectAll(getData('activate-element', el))
  const inputMagicBoxLogin = select(INPUT_MAGIC_BOX_LOGIN, el)

  const activateModalCheckUseGoogle = () => addClass(ACTIVATE_CLASS, el)
  const closedModalCheckUseGoogle = () => removeClass(ACTIVATE_CLASS, el)

  if (inputMagicBoxLogin && buttonFormCheckUseGoogle) {
    const inputMagicBoxLoginUrl = inputMagicBoxLogin.value
    const SSO_GOOGLE_LOGIN_REDIRECT_URL = `${window.location.origin}?google_ready_assessments_redirect=true`

    on('click', () => {
      addClass(ACTIVATE_CLASS, loadingFormCheckUseGoogle)
      const inputCheckUseGoogle = select(INPUT_RADIO_CHECK_USE_GOOGLE, formCheckUseGoogle)
      const checkUseGoogleValue = inputCheckUseGoogle ? Number(inputCheckUseGoogle.value) : 0
      const END_POINT_CHECK_USER_USE_GOOGLE = `${window.location.origin}/wp-json/ecl/v1/check_user_use_google_classroom?status=${checkUseGoogleValue}`

      fetchData(END_POINT_CHECK_USER_USE_GOOGLE).then(() => {
        removeClass(ACTIVATE_CLASS, loadingFormCheckUseGoogle)
        closedModalCheckUseGoogle()
        el.remove()

        if (checkUseGoogleValue === 1) {
          window.location.href = SSO_GOOGLE_LOGIN_REDIRECT_URL
        } else {
          window.location.href = inputMagicBoxLoginUrl
        }

      })
    }, buttonFormCheckUseGoogle)
  }

  if (openModalButton) {
    on('click', function (e) {
      e.preventDefault()
      activateModalCheckUseGoogle()
    }, openModalButton)
  }
}
